<template v-slot:body>
  <Api :config="config" :isTab="true"></Api>
</template>

<script>
import Api from "../../components/Api.vue";
export default {
  components: {
    Api,
  },
  data() {
    // Campos de cada sensor com valores de exemplo, baseados nos DTOs de resposta
    // da API (ReadResponse). Usados para montar a resposta dinâmica conforme os
    // sensores selecionados pelo usuário nos endpoints de leitura.
    const stationBase = {
      source_id: "default",
      datetime: "2024-04-22T13:35:19",
      model: "onStation",
      id: 0,
      battery: "1",
      temperature: 22.3,
      humidity: 84,
      pressure: 1006.41,
      wind_direction: 14,
      wind_speed: 2.52,
      gust_speed: 3.36,
      rainfall: 47.4,
      solar_radiation: 100.25,
      uvi: 0,
      light: 12632,
    };
    // No LastReadDay a estação traz campos calculados adicionais do dia.
    const stationLastRead = {
      ...stationBase,
      deltaT: 5.87,
      dayTotalRain: 1.2,
      temperatureMax: 28.5,
      temperatureMin: 16.1,
      humidityMax: 95,
      humidityMin: 62,
      daysSinceSignificantRain: 3,
    };
    const sensorSamples = {
      rain: [{ source_id: "default", model: "Rain", id: "0", rainfall: "12.4", battery: "1" }],
      hidro: [
        {
          source_id: "default",
          datetime: "2024-04-22T13:35:19",
          model: "Keller",
          protocol_id: "0",
          protocol: "4mA to 20mA",
          offset: "0",
          depth_max: "1",
          depth: "0.17",
          temperature: "22.3",
        },
      ],
      laser: [
        {
          source_id: "default",
          datetime: "2024-04-22T13:35:19",
          model: "Laser",
          protocol_id: "0",
          protocol: "Modbus",
          offset: "0",
          temperature: "22.3",
          depth: "0.42",
          depth_max: "2",
        },
      ],
      nivel: [
        {
          source_id: "default",
          datetime: "2024-04-22T13:35:19",
          model: "Nivel",
          protocol_id: "0",
          protocol: "Modbus",
          offset: "0",
          depth_max: "3",
          depth: "1.25",
          overflow_level: "2.8",
        },
      ],
      soil: [
        {
          source_id: "default",
          model: "Soil",
          protocol: "RS485",
          protocol_id: "0",
          depth: "30",
          temperature: "21.5",
          humidity: "38",
        },
      ],
      leaf: [
        {
          source_id: "default",
          model: "Leaf",
          protocol: "RS485",
          protocol_id: "0",
          temperature: "20.1",
          humidity: "76",
        },
      ],
      ath: [
        {
          source_id: "default",
          model: "ATH",
          protocol: "I2C",
          protocol_id: "0",
          temperature: "22.5",
          humidity: "84",
        },
      ],
      lut: [
        {
          source_id: "default",
          model: "LUT",
          protocol: "I2C",
          protocol_id: "0",
          lux: "12300",
          temperature: "22.4",
          humidity: "83",
        },
      ],
      // pyranometer temporariamente oculto do seletor (reativar removendo o comentário)
      // pyranometer: [
      //   {
      //     source_id: "default",
      //     model: "Pyranometer",
      //     protocol_id: "0",
      //     protocol: "RS485",
      //     IT: "850",
      //     DHI: "120",
      //     GHI: "780",
      //     POA: "810",
      //   },
      // ],
      ritter: [
        {
          source_id: "default",
          model: "Ritter",
          protocol: "RS485",
          protocol_id: "0",
          date: "2024-04-22T13:35:19",
          pulse: 12,
          pressure: 1.2,
          temperature: 22.3,
          totalLitersAccumulated: 1540.5,
          totalLitersToday: 32.7,
        },
      ],
      fotobio: [
        {
          source_id: "default",
          str: "fotobio",
          temp_1: 24.1,
          temp_2: 24.3,
          temp_3: 24.0,
          temp_4: 23.8,
          temp_5: 24.2,
          temp_6: 24.4,
          temp_amb: 22.5,
          lux_amb: 12300,
          hum_amb: 83,
          temp_amb2: 22.7,
          lux_amb2: 12100,
          hum_amb2: 82,
          datetime: "2024-04-22T13:35:19",
        },
      ],
      // power e powerSmtp temporariamente ocultos do seletor (reativar removendo o comentário)
      // power: [
      //   {
      //     source_id: "default",
      //     model: "Power",
      //     protocol_id: "0",
      //     protocol: "Modbus",
      //     total_energy: "1540.5",
      //     export_energy: "120.3",
      //     import_energy: "1420.2",
      //     V: "220.1",
      //     I: "5.4",
      //     P: "1.18",
      //     Kvar: "0.2",
      //     CosPhi: "0.98",
      //     F: "60.0",
      //   },
      // ],
      // powerSmtp: [
      //   {
      //     source_id: "default",
      //     model: "PowerSmtp",
      //     protocol: "Modbus",
      //     temperature: "35.2",
      //     temperature_battery: "30.1",
      //     operation_mode: "1",
      //     v_panel: "18.4",
      //     i_panel: "3.2",
      //     p_panel: "58.9",
      //     energy_generated: "240.5",
      //     v_battery: "12.6",
      //     i_battery: "2.1",
      //     status_battery: "1",
      //     capacity_battery: "85",
      //     control_load: "1",
      //   },
      // ],
    };
    // Catálogo padrão (ReadDayNow / ReadDay): estação base + demais sensores.
    const readDaySensors = {
      station: [stationBase],
      ...sensorSamples,
    };
    // Catálogo do LastReadDay: estação com campos do dia + demais sensores.
    const lastReadDaySensors = {
      station: [stationLastRead],
      ...sensorSamples,
    };
    const infoExample = {
      date: "2024-04-22T13:35:19",
      version_onconnect: "1.0.0",
      temperature_onconnect: 35.2,
      firmware_version: "2.1.0",
      wifi_cli_rssi: -45,
      origin: "wifi",
      utc: "-3",
      bateria_onconnect: 4.2,
    };
    return {
      config: [
        {
          title: "Api para Previsão do Tempo",
          data: [
            {
              title: "Buscar Cidade por Nome",
              caption:
                "Busca cidades cadastradas na base de dados onAgro pelo nome. Retorna uma lista de cidades que correspondem ao termo pesquisado, com limite de 50 resultados. O termo de busca deve ter no mínimo 2 caracteres. O \"id\" informado na resposta será utilizado para a busca de dados meteorológicos.",
              curlParam: [
                "Public Token: O token deve ser passado no header da requisição.",
                "cityName: Nome ou parte do nome da cidade que deseja buscar (mínimo 2 caracteres).",
              ],
              curlReturn1: [
                "Id: Identificador da cidade, utilizado para consultar a previsão do tempo posteriormente.",
                "Nome: Nome da cidade.",
                "Estado: Nome do estado que a cidade pertence.",
                "UF: Sigla do estado.",
              ],
              method: "curl",
              url: "curl --location 'https://api.onagro.com.br/api/WeatherForecast/SearchCity?cityName=Porto' \
                 --header 'x-api-key: public_token'",
              response: {
                200: {
                  description: "Resposta padrão",
                  example: {
                    data: [
                      {
                        id: 4314902,
                        nome: "Porto Alegre",
                        estado: "Rio Grande do Sul",
                        uf: "RS",
                      },
                      {
                        id: 1718204,
                        nome: "Porto Nacional",
                        estado: "Tocantins",
                        uf: "TO",
                      },
                      {
                        id: 1100205,
                        nome: "Porto Velho",
                        estado: "Rondônia",
                        uf: "RO",
                      },
                    ],
                  },
                },
                400: {
                  description: "Erro ao não passar o token ou termo de busca muito curto",
                  example: {
                    code: "400",
                    message: "City name search term must be at least 2 characters",
                    outputErrorMessage: {
                      message: "City name search term must be at least 2 characters",
                    },
                  },
                },
                401: {
                  description: "Erro na autenticação do token",
                  example: {
                    code: "401",
                    message: "Token is Invalid",
                    outputErrorMessage: {
                      message: "Token is Invalid",
                    },
                  },
                },
              },
            },
            {
              title: "Lista de Cidades Cadastradas",
              caption:
                "Lista todas as cidades cadastradas das na base de dados onAgro. O “id” informado na resposta será utilizado posteriormente para a busca de dados meteorológicos",
              curlParam: [
                "Public Token: O token deve ser passado no header da requisição.",
              ],
              curlReturn1: [
                "Id: Identificador da cidade, utilizado para consultar a previsão do tempo posteriormente.",
                "Nome: Nome da cidade.",
                "Estado: Nome do estado que a cidade pertence.",
                "UF: Sigla do estado.",
              ],
              recomendation:
                "Salvar os dados referentes a cidade na sua base de dados, para agilizar a consulta, pois são mais de 5 mil municípios, isso pode deixar a aplicação um pouco lenta caso seja consultado frequentemente a rota de aquisição de cidades.",
              method: "curl",
              url: "curl --location 'https://api.onagro.com.br/api/WeatherForecast/GetAllCity' \
                 --header 'x-api-key: public_token'",
              response: {
                200: {
                  description: "Resposta padrão",
                  example: {
                    data: [
                      {
                        id: 5200050,
                        nome: "Abadia de Goiás",
                        estado: "Goiás",
                        uf: "GO",
                      },
                      {
                        id: 3100104,
                        nome: "Abadia dos Dourados",
                        estado: "Minas Gerais",
                        uf: "MG",
                      },
                      {
                        id: 5200100,
                        nome: "Abadiânia",
                        estado: "Goiás",
                        uf: "GO",
                      },
                      {
                        id: 3100203,
                        nome: "Abaeté",
                        estado: "Minas Gerais",
                        uf: "MG",
                      },
                      {
                        id: 1500107,
                        nome: "Abaetetuba",
                        estado: "Pará",
                        uf: "PA",
                      },
                      {
                        id: 2300101,
                        nome: "Abaiara",
                        estado: "Ceará",
                        uf: "CE",
                      },
                      {
                        id: 2900108,
                        nome: "Abaíra",
                        estado: "Bahia",
                        uf: "BA",
                      },
                      {
                        id: 2900207,
                        nome: "Abaré",
                        estado: "Bahia",
                        uf: "BA",
                      },
                      {
                        id: 4100103,
                        nome: "Abatiá",
                        estado: "Paraná",
                        uf: "PR",
                      },
                      {
                        id: 4200051,
                        nome: "Abdon Batista",
                        estado: "Santa Catarina",
                        uf: "SC",
                      },
                      {
                        id: 1500131,
                        nome: "Abel Figueiredo",
                        estado: "Pará",
                        uf: "PA",
                      },
                      {
                        id: 4200101,
                        nome: "Abelardo Luz",
                        estado: "Santa Catarina",
                        uf: "SC",
                      },
                      {
                        id: 3100302,
                        nome: "Abre Campo",
                        estado: "Minas Gerais",
                        uf: "MG",
                      },
                      {
                        id: 2600054,
                        nome: "Abreu e Lima",
                        estado: "Pernambuco",
                        uf: "PE",
                      },
                      {
                        id: 1700251,
                        nome: "Abreulândia",
                        estado: "Tocantins",
                        uf: "TO",
                      },
                      {
                        id: 3100401,
                        nome: "Acaiaca",
                        estado: "Minas Gerais",
                        uf: "MG",
                      },
                      {
                        id: 2100055,
                        nome: "Açailândia",
                        estado: "Maranhão",
                        uf: "MA",
                      },
                      {
                        id: 2900306,
                        nome: "Acajutiba",
                        estado: "Bahia",
                        uf: "BA",
                      },
                      "...",
                    ],
                  },
                },
                400: {
                  description: "Erro ao não passar o token",
                  example: {
                    code: "400",
                    message: "Token is Empty",
                    outputErrorMessage: {
                      message: "Token is Empty",
                    },
                  },
                },
                401: {
                  description: "Erro na autenticação do token",
                  example: {
                    code: "401",
                    message: "Token is Invalid",
                    outputErrorMessage: {
                      message: "Token is Invalid",
                    },
                  },
                },
              },
            },
            {
              title: "Previsão do tempo atual de todas as cidades",
              caption:
                "Retorna a previsão do tempo da hora atual (arredondada) para todas as cidades cadastradas na base de dados onAgro. Útil para obter um panorama geral sem precisar consultar cidade por cidade.",
              curlParam: [
                "Public Token: O token deve ser passado no header da requisição.",
              ],
              curlReturnTitle1: "Dados de previsão do tempo (por cidade):",
              curlReturn1: [
                "Id: Identificador interno do registro de clima da cidade.",
                "cidade_id: Identificador da cidade (o mesmo id da rota /GetAllCity).",
                "nome: Nome da cidade.",
                "estado: Nome do estado que a cidade pertence.",
                "uf: Sigla do estado.",
                "latitude: Latitude da cidade para ser usado em mapas.",
                "longitude: Longitude da cidade para ser usado em mapas.",
                "data: Data e hora de referência da previsão.",
                "temperatura: Temperatura esperada em Grau Celsius.",
                "umidade: Umidade relativa do ar em %.",
                "precipitacao: Precipitação registrada em mm.",
                "precipitacao_prevista: Precipitação prevista em mm.",
                "vento_velocidade: Velocidade do vento em km/h.",
              ],
              recomendation:
                "Como retorna todas as cidades cadastradas de uma vez, prefira esta rota apenas quando precisar do panorama completo. Para uma cidade específica, utilize as rotas /GetByHour ou /GetByHourAndDateNow.",
              method: "curl",
              url: "curl --location 'https://api.onagro.com.br/api/WeatherForecast/GetByWeatherForecast' \
                 --header 'x-api-key: public_token'",
              response: {
                200: {
                  description: "Resposta padrão",
                  example: {
                    data: [
                      {
                        Id: 1,
                        cidade_id: 4311403,
                        nome: "Lajeado",
                        estado: "Rio Grande do Sul",
                        uf: "RS",
                        latitude: -29.4591,
                        longitude: -51.9644,
                        data: "2024-04-22T13:00:00",
                        temperatura: 22.3,
                        umidade: 84,
                        precipitacao: 0.0,
                        precipitacao_prevista: 1.2,
                        vento_velocidade: 3.4,
                      },
                      "...",
                    ],
                  },
                },
                400: {
                  description: "Erro ao não passar o token",
                  example: {
                    code: "400",
                    message: "Token is Empty",
                    outputErrorMessage: {
                      message: "Token is Empty",
                    },
                  },
                },
                401: {
                  description: "Erro na autenticação do token",
                  example: {
                    code: "401",
                    message: "Token is Invalid",
                    outputErrorMessage: {
                      message: "Token is Invalid",
                    },
                  },
                },
              },
            },
            {
              title:
                "Previsão do tempo para o dia atual mas de uma hora específica",
              caption:
                "Retorna da base de dados a previsão do tempo de uma cidade específica, do dia em que a consulta foi realizada.",
              curlParam: [
                "Public Token: O token deve ser passado no header da requisição.",
                "CityID: É o “id” da cidade que é apresentado com na rota /GetAllCity.",
                "hour: É a hora da previsão do tempo que você deseja consultar.",
              ],
              curlReturnTitle1: "Dados de previsão do tempo:",
              curlReturn1: [
                "data_referencia: Data e hora da previsão do tempo.",
                "temperatura_max: Temperatura máxima esperada na hora solicitada.",
                "temperatura_min: Temperatura minima esperada na hora solicitada.",
                "temperatura: A temperatura esperada para o momento da solicitação.",
                "vento_velocidade_media: Velocidade média do vento em km/h.",
                "precipitacao_total: O total de chuva esperada para a hora solicitada.",
              ],
              curlReturnTitle2:
                "Dados referentes a cidade que a previsão pertence:",
              curlReturn2: [
                "id: Identificador da cidade, o mesmo da requisição.",
                "nome: Nome da cidade.",
                "estado: Unidade federativa que a cidade pertence.",
                "latitude: Latitude da cidade para ser usado em mapas.",
                "longitude: Longitude da cidade para ser utilizado em mapas.",
                "uf: Sigla da unidade federativa que a cidade pertence",
              ],
              method: "curl",
              url: "curl --location 'https://api.onagro.com.br/api/WeatherForecast/GetByHourAndDateNow/<CityID>?hour=14:00' \
                 --header 'x-api-key: public_token'",
              response: {
                200: {
                  description: "Resposta padrão",
                  example: {
                    data: {
                      data_referencia: "2024-04-01T08:00:00",
                      temperatura_max: 33.3,
                      temperatura_min: 17.7,
                      temperatura: 18.1,
                      vento_velocidade_media: 3.4041666666666666666666666667,
                      precipitacao_total: 0.0,
                      cidade: {
                        id: 4311403,
                        nome: "Lajeado",
                        estado: "Rio Grande do Sul",
                        latitude: -29.4591,
                        longitude: -51.9644,
                        uf: "RS",
                      },
                    },
                  },
                },
                400: {
                  description: "Erro ao não passar o token",
                  example: {
                    code: "400",
                    message: "Token is Empty",
                    outputErrorMessage: {
                      message: "Token is Empty",
                    },
                  },
                },
                401: {
                  description: "Erro na autenticação do token",
                  example: {
                    code: "401",
                    message: "Token is Invalid",
                    outputErrorMessage: {
                      message: "Token is Invalid",
                    },
                  },
                },
              },
            },
            {
              title: "Previsão do tempo para 5 dias para uma hora específica",
              caption:
                "Mostra a previsão do tempo para os próximos 5 dias, para a hora informada.",
              curlParam: [
                "Public Token: O token deve ser passado no header da requisição.",
                "CityID: É o “id” da cidade que é apresentado com na rota /GetAllCity.",
                "hour: É a hora da previsão do tempo que você deseja consultar.",
              ],
              curlReturnTitle1: "Dados de previsão do tempo:",
              curlReturn1: [
                "data_referencia: Data e hora da previsão do tempo.",
                "temperatura_max: Temperatura máxima esperada na hora solicitada.",
                "temperatura_min: Temperatura minima esperada na hora solicitada.",
                "temperatura: A temperatura esperada para o momento da solicitação.",
                "vento_velocidade_media: Velocidade média do vento em km/h.",
                "precipitacao_total: O total de chuva esperada para a hora solicitada.",
              ],
              curlReturnTitle2:
                "Dados referentes a cidade que a previsão pertence:",
              curlReturn2: [
                "id: Identificador da cidade, o mesmo da requisição.",
                "nome: Nome da cidade.",
                "estado: Unidade federativa que a cidade pertence.",
                "latitude: Latitude da cidade para ser usado em mapas.",
                "longitude: Longitude da cidade para ser utilizado em mapas.",
                "uf: Sigla da unidade federativa que a cidade pertence.",
              ],
              method: "curl",
              url: "curl --location 'https://api.onagro.com.br/api/WeatherForecast/GetByHour/<CityID>?hour=14:00' \
                --header 'x-api-key: public_token'",
              response: {
                200: {
                  description: "Resposta padrão",
                  example: {
                    data: [
                      {
                        data_referencia: "2024-03-26T08:00:00",
                        temperatura_max: 28.8,
                        temperatura_min: 15.9,
                        temperatura: 15.9,
                        vento_velocidade_media: 5.8583333333333333333333333333,
                        precipitacao_total: 0.0,
                        cidade: {
                          id: 4311403,
                          nome: "Lajeado",
                          estado: "Rio Grande do Sul",
                          latitude: -29.4591,
                          longitude: -51.9644,
                          uf: "RS",
                        },
                      },
                      {
                        data_referencia: "2024-03-27T08:00:00",
                        temperatura_max: 30.3,
                        temperatura_min: 14.6,
                        temperatura: 15.0,
                        vento_velocidade_media: 4.4375,
                        precipitacao_total: 0.0,
                        cidade: {
                          id: 4311403,
                          nome: "Lajeado",
                          estado: "Rio Grande do Sul",
                          latitude: -29.4591,
                          longitude: -51.9644,
                          uf: "RS",
                        },
                      },
                      {
                        data_referencia: "2024-03-28T08:00:00",
                        temperatura_max: 32.1,
                        temperatura_min: 16.8,
                        temperatura: 17.1,
                        vento_velocidade_media: 3.1541666666666666666666666667,
                        precipitacao_total: 2.0,
                        cidade: {
                          id: 4311403,
                          nome: "Lajeado",
                          estado: "Rio Grande do Sul",
                          latitude: -29.4591,
                          longitude: -51.9644,
                          uf: "RS",
                        },
                      },
                      {
                        data_referencia: "2024-03-29T08:00:00",
                        temperatura_max: 30.1,
                        temperatura_min: 18.9,
                        temperatura: 19.1,
                        vento_velocidade_media: 4.925,
                        precipitacao_total: 10.89,
                        cidade: {
                          id: 4311403,
                          nome: "Lajeado",
                          estado: "Rio Grande do Sul",
                          latitude: -29.4591,
                          longitude: -51.9644,
                          uf: "RS",
                        },
                      },
                      {
                        data_referencia: "2024-03-30T08:00:00",
                        temperatura_max: 31.4,
                        temperatura_min: 17.4,
                        temperatura: 18.7,
                        vento_velocidade_media: 4.7958333333333333333333333333,
                        precipitacao_total: 0.0,
                        cidade: {
                          id: 4311403,
                          nome: "Lajeado",
                          estado: "Rio Grande do Sul",
                          latitude: -29.4591,
                          longitude: -51.9644,
                          uf: "RS",
                        },
                      },
                    ],
                  },
                },
                400: {
                  description: "Erro ao não passar o token",
                  example: {
                    code: "400",
                    message: "Token is Empty",
                    outputErrorMessage: {
                      message: "Token is Empty",
                    },
                  },
                },
                401: {
                  description: "Erro na autenticação do token",
                  example: {
                    code: "401",
                    message: "Token is Invalid",
                    outputErrorMessage: {
                      message: "Token is Invalid",
                    },
                  },
                },
              },
            },
          ],
        },
        {
          title: "Api para Dispositivos onAgro",
          data: [
            {
              CSharpCode: true,
            },
            {
              title: "Lista de dispositivos onAgro",
              curlParam: ["Public Token: O token deve ser passado no header da requisição.",],
              caption:"Lista todos os dispositivos onAgro ativos na conta ou dispositivos que foram compartilhados com o usuário proprietário da chave de API da consulta. A lista de dispositivos é retornada na chave \"itens\" da resposta.",
              curlReturnTitle1: "Dados do dispositivo (cada item da lista \"itens\"):",
              curlReturn1: [
                "identifier: Identificador que será utilizado para consultar a leitura do dispositivo.",
                "qrCode: Código identificador único do dispositivo.",
                "name: Nome dado ao dispositivo pelo usuário na hora do cadastro.",
                "type: Tipo de dispositivo (urbano ou rural).",
                "module: Tipo de módulo (onConnect ou onStation).",
                "status: Status de operação do dispositivo (1 = pendente, 2 = offline, 3 = online).",
              ],
              curlReturnTitle2: "Dados do endereço (addressData):",
              curlReturn2: [
                "name: Nome da localização.",
                "neighborhood: Bairro onde foi instalado o dispositivo.",
                "address: Dados complementares, como rua e número do endereço.",
                "city: Cidade onde foi instalado o dispositivo.",
                "uf: Unidade federativa onde foi instalado o dispositivo.",
                "cep: Número do CEP.",
              ],
              method: "curl",
              url: "curl --location 'https://api.onagro.com.br/api/Devices' --header 'x-api-key: public_token'",
              response: {
                200: {
                  description: "Resposta padrão",
                  example: {
                    itens: [
                      {
                        identifier: 1,
                        qrCode: "2023110711470",
                        name: "LabDevice",
                        type: "urbano",
                        module: "onConnect",
                        addressData: {
                          name: "Univates",
                          neighborhood: "Carneiros",
                          address: "Rua Bento Rosa",
                          city: "Lajeado",
                          uf: "Rio Grande do Sul",
                          cep: "95913-470",
                        },
                        status: 3,
                      },
                    ],
                  },
                },
                400: {
                  description: "Erro ao não passar o token",
                  example: {
                    code: "400",
                    message: "Token is Empty",
                    outputErrorMessage: {
                      message: "Token is Empty",
                    },
                  },
                },
                401: {
                  description: "Erro na autenticação do token",
                  example: {
                    code: "401",
                    message: "Token is Invalid",
                    outputErrorMessage: {
                      message: "Token is Invalid",
                    },
                  },
                },
              },
            },
            {
              title: "Última leitura salva",
              curlParam: [
                "DeviceId: Esse campo equivale ao identifier do retorno da lista de dispositivos, ele que vai selecionar o dispositivo que será consultado.",
                "Public Token: O token deve ser passado no header da requisição.",
              ],
              caption:"Consulta qual foi a última leitura realizada por um dispositivo. A resposta contém os dados dos sensores conectados (estação meteorológica, pluviômetro, sondas, solo, foliar, ambiente, LUT, ritter, fotobio) dentro do objeto \"itens\", e as informações do módulo de coleta dentro do objeto \"Info\" (este endpoint é o único que retorna \"Info\"). Cada tipo de sensor é uma lista dentro de \"itens\". Observação: sensores e campos sem valor são omitidos do JSON (não aparecem como null); o valor 0 é uma medição real e sempre aparece.",
              curlReturnTitle1: "Tipos de sensores disponíveis em itens:",
              curlReturn1: [
                "station: Leituras da estação meteorológica.",
                "rain: Leituras do pluviômetro (rainfall, battery).",
                "hidro: Leituras da sonda hidrostática.",
                "laser: Leituras da sonda laser.",
                "nivel: Leituras da sonda de nível (inclui overflow_level).",
                "tank: Leituras de caixa d'água (inclui height, diameter/side1/side2 conforme o formato).",
                "soil: Leituras do sensor de solo (profundidade, temperatura e umidade).",
                "leaf: Leituras do sensor foliar (temperatura e umidade).",
                "ath: Leituras do sensor de ambiente (temperatura e umidade).",
                "lut: Leituras do sensor LUT (lux, temperatura e umidade).",
                "ritter: Leituras do medidor de gás Ritter (pulso, pressão, litros).",
                "fotobio: Leituras do sensor de fotobiologia (temp_1..temp_6 e dados de ambiente).",
                "info: Informações do módulo de coleta (firmware, bateria, etc.).",
              ],
              curlReturnTitle2: "Campos da estação meteorológica (station):",
              curlReturn2: [
                "source_id: Identificador da fonte do sensor (ex: 'default').",
                "datetime: Data e hora do momento que a leitura foi realizada.",
                "model: Modelo da estação.",
                "id: Identificador da estação (uso interno onAgro).",
                "battery: Indica se a bateria da estação está em boas condições ou precisa ser substituída.",
                "temperature: Temperatura ambiente em Grau Celsius.",
                "humidity: Umidade ambiente em %.",
                "pressure: Pressão em hPa.",
                "wind_direction: Direção do vento em Grau, sendo Zero e 360 o norte.",
                "wind_speed: Velocidade do vento em km/h.",
                "gust_speed: Rajada do vento em km/h.",
                "rainfall: Acumulado de chuva da estação em mm.",
                "solar_radiation: Radiação solar em W/m².",
                "uvi: Índice de radiação ultravioleta (0-15).",
                "light: Luminosidade em Lux.",
                "deltaT: Diferença entre temperatura e ponto de orvalho em Grau Celsius (somente LastReadDay).",
                "dayTotalRain: Total de chuva do dia em mm (somente LastReadDay).",
                "temperatureMax: Temperatura máxima do dia em Grau Celsius (somente LastReadDay).",
                "temperatureMin: Temperatura mínima do dia em Grau Celsius (somente LastReadDay).",
                "humidityMax: Umidade máxima do dia em % (somente LastReadDay).",
                "humidityMin: Umidade mínima do dia em % (somente LastReadDay).",
                "daysSinceSignificantRain: Dias desde a última chuva significativa >= 2mm (somente LastReadDay).",
              ],
              method: "curl",
              url: "curl --location 'https://api.onagro.com.br/api/Devices/<DeviceId>/LastReadDay' --header 'x-api-key: public_token'",
              response: {
                200: {
                  description: "Resposta padrão (sensores sem dados são omitidos da resposta). Selecione abaixo os sensores do seu dispositivo para ver como fica a resposta.",
                  wrapKey: "itens",
                  sensors: lastReadDaySensors,
                  extra: { Info: infoExample },
                },
                400: {
                  description: "Erro ao não passar o token",
                  example: {
                    code: "400",
                    message: "Token is Empty",
                    outputErrorMessage: {
                      message: "Token is Empty",
                    },
                  },
                },
                401: {
                  description: "Erro na autenticação do token",
                  example: {
                    code: "401",
                    message: "Token is Invalid",
                    outputErrorMessage: {
                      message: "Token is Invalid",
                    },
                  },
                },
              },
            },
            {
              title: "Leituras do Dia Atual",
              curlParam: [
                "DeviceId: Esse campo equivale ao identifier do retorno da lista de dispositivos, ele que vai selecionar.",
                "Public Token: O token deve ser passado no header da requisição.",
              ],
              caption:
                "Lista todas as leituras disponíveis do dia em que a requisição foi realizada, retornando todas as leituras com um espaçamento de aproximadamente 5 minutos. As leituras vêm dentro do objeto \"itens\". Sensores e campos sem valor são omitidos do JSON (não aparecem como null); o valor 0 é uma medição real e sempre aparece. Diferente do LastReadDay, este endpoint não retorna o objeto \"Info\".",
              method: "curl",
              curlReturnTitle1: "Tipos de sensores disponíveis em itens:",
              curlReturn1: [
                "station: Leituras da estação meteorológica.",
                "rain: Leituras do pluviômetro (rainfall, battery).",
                "hidro: Leituras da sonda hidrostática.",
                "laser: Leituras da sonda laser.",
                "nivel: Leituras da sonda de nível (inclui overflow_level).",
                "tank: Leituras de caixa d'água (inclui height, diameter/side1/side2 conforme o formato).",
                "soil: Leituras do sensor de solo (profundidade, temperatura e umidade).",
                "leaf: Leituras do sensor foliar (temperatura e umidade).",
                "ath: Leituras do sensor de ambiente (temperatura e umidade).",
                "lut: Leituras do sensor LUT (lux, temperatura e umidade).",
                "ritter: Leituras do medidor de gás Ritter (pulso, pressão, litros).",
                "fotobio: Leituras do sensor de fotobiologia (temp_1..temp_6 e dados de ambiente).",
              ],
              curlReturnTitle2: "Campos da estação meteorológica (station):",
              curlReturn2: [
                "source_id: Identificador da fonte do sensor (ex: 'default').",
                "datetime: Data e hora do momento que a leitura foi realizada.",
                "model: Modelo da estação.",
                "id: Identificador da estação (uso interno onAgro).",
                "battery: Indica se a bateria da estação está em boas condições ou precisa ser substituída.",
                "temperature: Temperatura ambiente em Grau Celsius.",
                "humidity: Umidade ambiente em %.",
                "pressure: Pressão em hPa.",
                "wind_direction: Direção do vento em Grau, sendo Zero e 360 o norte.",
                "wind_speed: Velocidade do vento em km/h.",
                "gust_speed: Rajada do vento em km/h.",
                "rainfall: Acumulado de chuva da estação em mm.",
                "solar_radiation: Radiação solar em W/m².",
                "uvi: Índice de radiação ultravioleta (0-15).",
                "light: Luminosidade em Lux.",
              ],
              url: "curl --location 'https://api.onagro.com.br/api/Devices/<DeviceId>/ReadDayNow' --header 'x-api-key: public_token'",
              response: {
                200: {
                  description: "Resposta padrão (sensores sem dados são omitidos da resposta). Selecione abaixo os sensores do seu dispositivo para ver como fica a resposta.",
                  wrapKey: "itens",
                  sensors: readDaySensors,
                },
                400: {
                  description: "Erro ao não passar o token",
                  example: {
                    code: "400",
                    message: "Token is Empty",
                    outputErrorMessage: {
                      message: "Token is Empty",
                    },
                  },
                },
                401: {
                  description: "Erro na autenticação do token",
                  example: {
                    code: "401",
                    message: "Token is Invalid",
                    outputErrorMessage: {
                      message: "Token is Invalid",
                    },
                  },
                },
              },
            },
            {
              title: "Leituras de um Dia Específico",
              curlParam: [
                "DeviceId: Esse campo equivale ao identifier do retorno da lista de dispositivos, ele que vai selecionar o dispositivo que será consultado.",
                "AAAA-MM-DD: Ano, mês e dia, da leitura a ser consultada.",
                "Public Token: O token deve ser passado no header da requisição.",
              ],
              caption:
                "Lista todas as leituras disponíveis na data informada na requisição, retornando todas as leituras com um espaçamento de aproximadamente 5 minutos. As leituras vêm dentro do objeto \"itens\". Sensores e campos sem valor são omitidos do JSON (não aparecem como null); o valor 0 é uma medição real e sempre aparece. Diferente do LastReadDay, este endpoint não retorna o objeto \"Info\".",
              curlReturnTitle1: "Tipos de sensores disponíveis em itens:",
              curlReturn1: [
                "station: Leituras da estação meteorológica.",
                "rain: Leituras do pluviômetro (rainfall, battery).",
                "hidro: Leituras da sonda hidrostática.",
                "laser: Leituras da sonda laser.",
                "nivel: Leituras da sonda de nível (inclui overflow_level).",
                "tank: Leituras de caixa d'água (inclui height, diameter/side1/side2 conforme o formato).",
                "soil: Leituras do sensor de solo (profundidade, temperatura e umidade).",
                "leaf: Leituras do sensor foliar (temperatura e umidade).",
                "ath: Leituras do sensor de ambiente (temperatura e umidade).",
                "lut: Leituras do sensor LUT (lux, temperatura e umidade).",
                "ritter: Leituras do medidor de gás Ritter (pulso, pressão, litros).",
                "fotobio: Leituras do sensor de fotobiologia (temp_1..temp_6 e dados de ambiente).",
              ],
              curlReturnTitle2: "Campos da estação meteorológica (station):",
              curlReturn2: [
                "source_id: Identificador da fonte do sensor (ex: 'default').",
                "datetime: Data e hora do momento que a leitura foi realizada.",
                "model: Modelo da estação.",
                "id: Identificador da estação (uso interno onAgro).",
                "battery: Indica se a bateria da estação está em boas condições ou precisa ser substituída.",
                "temperature: Temperatura ambiente em Grau Celsius.",
                "humidity: Umidade ambiente em %.",
                "pressure: Pressão em hPa.",
                "wind_direction: Direção do vento em Grau, sendo Zero e 360 o norte.",
                "wind_speed: Velocidade do vento em km/h.",
                "gust_speed: Rajada do vento em km/h.",
                "rainfall: Acumulado de chuva da estação em mm.",
                "solar_radiation: Radiação solar em W/m².",
                "uvi: Índice de radiação ultravioleta (0-15).",
                "light: Luminosidade em Lux.",
              ],
              method: "curl",
              url: "curl --location 'https://api.onagro.com.br/api/Devices/<DeviceId>/ReadDay/<AAAA-MM-DD>' --header 'x-api-key: public_token'",
              response: {
                200: {
                  description: "Resposta padrão (sensores sem dados são omitidos da resposta). Selecione abaixo os sensores do seu dispositivo para ver como fica a resposta.",
                  wrapKey: "itens",
                  sensors: readDaySensors,
                },
                400: {
                  description: "Erro ao não passar o token",
                  example: {
                    code: "400",
                    message: "Token is Empty",
                    outputErrorMessage: {
                      message: "Token is Empty",
                    },
                  },
                },
                401: {
                  description: "Erro na autenticação do token",
                  example: {
                    code: "401",
                    message: "Token is Invalid",
                    outputErrorMessage: {
                      message: "Token is Invalid",
                    },
                  },
                },
              },
            },
          ],
        },
      ],
    };
  },
};
</script>
